<div style="border-bottom: 4px solid #F1F1F1;">
    <div class="container p-3 px-xl-0">
        <img src="/assets/icons/Branding.svg" alt="Kaercher Branding">
    </div>
</div>
